import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import { Card, Col, Row, Tag } from 'antd';
import ReactEcharts from '../../Echarts/Echarts';
import { objectOfObject } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import {
  trendLabelTranslationNew,
  predictionsLegendsTranslation
} from '../../../Utils/Adapter/translationAdapter';

const CountersPie = (props) => {

  const option = getOption();
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [option1, setOption1] = useState({});
  const [option2, setOption2] = useState({});
  const [counter, setCounter] = useState();
  const [pie, setPie] = useState([]);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  let abortController = useRef(new window.AbortController());
  

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  // useEffect(() => {
  //   return () => {
  //       abortController.current.abort();
  //     clearInterval(timeTicket);
  //   };
  // });

  const getData = async (props, theme) => {
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = objectOfObject;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      let counter = [];
      counter = json && json.query ? json.query : [];
      let pie = json && json.query1 ? json.query1 : [];
      if (pie && Array.isArray(pie) && pie[0]) {
        let option1 = cloneDeep(option);
        let legend = {
          left: 'center',
          textStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
            fontSize: 18,
            fontWeight: 'bold'
          }
        };

        let series = await trendLabelTranslationNew([pie[0]], props.translationCache);
        let legends = await predictionsLegendsTranslation(legend, props.translationCache);

        option1.series[0].data = series;

        option1.legend = legends;
        setOption1(option1);
        setRefreshDateTime(moment());
      }

      if (pie && Array.isArray(pie) && pie[1]) {
        let option2 = cloneDeep(option);
        let legend = {
          left: 'center',
          textStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white',
            fontSize: 18,
            fontWeight: 'bold'
          }
        };

        let series = await trendLabelTranslationNew([pie[1]], props.translationCache);
        let legends = await predictionsLegendsTranslation(legend, props.translationCache);

        option2.series[0].data = series;

        option2.legend = legends;
        setOption2(option2);
        setRefreshDateTime(moment());
      }

      if (counter && Array.isArray(counter)) {
        setCounter(counter);
      }
      setPie(pie);
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };
  function getOption() {
    let option = {
      series: [
        {
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false
          },
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'white'
            }
          },
          axisLine: {
            lineStyle: {
              width: 30
            }
          },
          splitLine: {
            show: false,
            distance: 0,
            length: 10
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            distance: 50
          },
          data: [],
          title: {
            fontSize: 11,
            fontWeight: 'bold',
            color: 'white',
            offsetCenter: [0, '0%']
          },
          detail: {
            width: 5,
            height: 5,
            fontSize: 12,
            formatter: '{value}',
            color: 'white',
            valueAnimation: true,
            offsetCenter: ['0%', '15%']
          }
        }
      ]
    };

    return option;
  }

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <Row>
          <Col span={pie && pie[1] ? 8 : 12} style={{ top: 100 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginLeft: '30px',
                justifyContent: 'space-between'
              }}
            >
              {counter && Array.isArray(counter)
                ? counter.map((counterData) => {
                  return (
                    <Card
                      key={counterData}
                      style={{ background: 'rgb(38, 38, 38)', marginBottom: '23px' }}
                      title={
                        <div
                          style={{ display: 'flex', justifyContent: 'center', color: 'white' }}
                        >
                          {counterData.Description}
                        </div>
                      }
                      bordered={true}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          color: 'white'
                        }}
                      >
                        {counterData.Value}
                      </div>
                    </Card>
                  );
                })
                : null}
            </div>
          </Col>
          <Col span={pie && pie[1] ? 8 : 12}>
            <ReactEcharts
              option={option1}
              notMerge={true}
              lazyUpdate={true}
              className="react_for_echarts"
            />
          </Col>
          {pie && pie[1] ? (
            <Col span={8}>
              <ReactEcharts
                option={option2}
                notMerge={true}
                lazyUpdate={true}
                className="react_for_echarts"
              />
            </Col>
          ) : null}
        </Row>
      )}
    </Fragment>
  );
};



const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(CountersPie);
